// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

import StockAlertModalComponent from 'Components/Header/StockAlertModal';
import useModals from 'Hooks/useModals';
import useUser from 'Hooks/useUser';
import useToastNotifications from 'Hooks/useToastNotifications';
import useWishlists from 'Hooks/useWishlists';
import useAnalytics from 'Hooks/useAnalytics';

const defaultValues = {
  additionalEmail: '',
};

const StockAlertModal = () => {
  const {
    register,
    trigger,
    reset,
    watch,
    formState: { errors }
  } = useForm({ defaultValues, mode: 'onChange' });
  const { data: user } = useUser();
  const wishlistContext = useWishlists();
  const toast = useToastNotifications();
  const { t } = useTranslation();
  const modalContext = useModals();
  const analytics = useAnalytics();
  const { key, state } = modalContext.modalState.STOCK_ALERT;
  const { productId, productCode, productQuantity, open: modalOpen } = state;

  const primaryEmail = user?.email;
  const additionalEmail = watch('additionalEmail');

  const [primaryChecked, setPrimaryChecked] = useState(true);
  const [additionalChecked, setAdditionalChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const resetModal = () => {
    reset(defaultValues);
    setPrimaryChecked(true);
    setAdditionalChecked(false);
  };

  const handleOnClose = () => {
    modalContext.closeModal(key);
    resetModal();

    setTimeout(() => {
      modalContext.resetModal(key);
    }, 250);
  };

  const handleOnConfirm = async () => {
    await trigger();

    analytics.track('stock_alert_modal_submitted', { with_additional_email: additionalChecked });

    const emails = [];

    if (primaryChecked) {
      emails.push(primaryEmail);
    }

    if (additionalChecked) {
      emails.push(additionalEmail);
    }

    const payload = {
      products: [
        {
          productId,
          quantity: productQuantity
        }
      ],
      emails,
    };

    setIsLoading(true);
    try {
      if (wishlistContext?.stockAlertWishlist) {
        await wishlistContext.updateList(wishlistContext.stockAlertWishlist.id, payload);
        handleOnClose();
        toast.addNotification({
          title: t('wishlists.addedToStockAlert')
        });
      }
    } catch (err) {
      toast.addNotification({
        type: 'error',
        title: err?.info?.errors?.at(0)?.message
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StockAlertModalComponent
      open={ modalOpen }
      code={ productCode }
      primaryEmail={ primaryEmail }
      primaryChecked={ primaryChecked }
      setPrimaryChecked={ setPrimaryChecked }
      additionalEmail={ additionalEmail }
      additionalChecked={ additionalChecked }
      setAdditionalChecked={ setAdditionalChecked }
      isLoading={ isLoading }
      handleConfirm={ handleOnConfirm }
      handleClose={ handleOnClose }
      register={ register }
      errors={ errors }
    />
  );
};

StockAlertModal.displayName = 'StockAlertModal';

export default StockAlertModal;
